/**
 * @file Decides whether the current URL is a tokenised booking link.
 * @module utils/bookingLinkRouteGuard
 *
 * S9 of ClickUp 86d2w0fwz. Extracted as a pure function for the same reason as
 * `patientFormRouteGuard.ts` next to it: `src/App.test.tsx` is excluded from `jest.config.js`
 * (it needs Vite's `import.meta.env`), so nothing decided inside `App.tsx` can be tested where
 * it lives. `App.tsx` keeps only the URL read.
 *
 * ⚠️ ITS ONLY JOB IS SUPPRESSING `XoeWidget`, AND THAT IS NOT COSMETIC. The widget is
 * root-mounted OUTSIDE `<Routes>` and outside `<Layout>`, so it is the one piece of chrome a
 * deliberately chrome-free patient page would still show — and it is an AI assistant with
 * clinical tool access carrying the PRACTITIONER'S OWN token. A practitioner previewing the
 * link they just issued would otherwise hand a patient-facing screen a clinical assistant.
 * Same reasoning, same shape, as `isHandoverRoute` (F10).
 *
 * This is NOT an auth gate and must never be read as one — `/patient/booking-form` is a public
 * route by design, and the booking link's own credential is enforced server-side by
 * `EnsureBookingLinkToken`.
 */

/** The public booking page. A bare visit (no `?t=`) is the anonymous booking flow. */
const BOOKING_FORM_PATH = "/patient/booking-form";

export const isTokenisedBookingRoute = (pathname: string, search: string): boolean => {
	if (pathname !== BOOKING_FORM_PATH) return false;

	// An empty `?t=` is not a token — the backend refuses it and the page runs anonymously,
	// so the widget rule must agree.
	const token = new URLSearchParams(search).get("t");
	return typeof token === "string" && token !== "";
};
